import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { services, company } from '../data/content';
import { CheckIcon, ArrowRightIcon } from './icons';
const ease = [0.23, 1, 0.32, 1] as const;
export function Services() {
  const [activeIndex, setActiveIndex] = useState(0);
  return <section id="services" className="w-full bg-navy-900 py-20 lg:py-28" data-id="element-612" data-mp="18vr0jvuuepkm">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-613" data-mp="13vl6k913oqzd">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-614" data-mp="13x61w0v8odya">
          <div className="max-w-2xl" data-id="element-615" data-mp="z3ldn0jg6yca">
            <p className="text-sm font-semibold text-sky-300" data-id="element-616" data-mp="u61o34hauz51">Services</p>
            <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-617" data-mp="u3yxojc8j3zs">
              Everything your backyard needs, done by one crew.
            </h2>
          </div>
          <a href={company.phoneHref} className="inline-flex shrink-0 items-center gap-2 font-display text-base font-bold text-sky-300 transition-colors duration-150 ease-out hover:text-sky-200" data-id="element-618" data-mp="g6ad7cm2xyv9">
            Free estimate on any service
            <ArrowRightIcon className="h-4 w-4" data-id="element-619" data-mp="3b47ygpmgkrwd" />
          </a>
        </div>

        {/* Desktop: expanding panels */}
        <div className="mt-12 hidden h-[460px] gap-3 lg:flex" data-id="element-620" data-mp="2xdclp28u9qni">
          {services.map((service, index) => {
          const isActive = index === activeIndex;
          return <motion.button key={service.name} type="button" onMouseEnter={() => setActiveIndex(index)} onFocus={() => setActiveIndex(index)} onClick={() => setActiveIndex(index)} aria-expanded={isActive} animate={{
            flexGrow: isActive ? 5 : 1
          }} transition={{
            duration: 0.3,
            ease
          }} className="relative block h-full basis-0 overflow-hidden rounded-lg text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-300" data-id="element-621" data-mp="3pzx95rm71ils" data-mpi={index}>
                <img src={service.image} alt={service.imageAlt} className="absolute inset-0 h-full w-full object-cover" data-id="element-622" data-mp="29n04f0rpehk9" />
                <span aria-hidden="true" className={`absolute inset-0 transition-colors duration-200 ease-out ${isActive ? 'bg-navy-900/70' : 'bg-navy-900/85'}`} data-id="element-623" data-mp="1pm6xzidz72px" />

                <span className="relative flex h-full flex-col justify-end p-6" data-id="element-624" data-mp="1gqqz2myd5xdh">
                  <service.icon className={`absolute left-6 top-6 h-7 w-7 transition-colors duration-200 ease-out ${isActive ? 'text-sky-300' : 'text-white/70'}`} data-id="element-625" data-mp="1bt7gxbyjp0g9" />
                  <span className="block font-display text-xl font-bold leading-tight text-white" data-id="element-626" data-mp="16r8goay3qjnj">
                    {service.name}
                  </span>

                  <AnimatePresence initial={false} data-id="element-627" data-mp="xtpqks5lpf4s">
                    {isActive && <motion.span initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: 10
                }} transition={{
                  duration: 0.22,
                  ease
                }} className="mt-3 block max-w-md" data-id="element-628" data-mp="sud3q7eqc827">
                        <span className="block text-[15px] leading-relaxed text-navy-100" data-id="element-629" data-mp="2zpou948e0p1r">
                          {service.body}
                        </span>
                        <span className="mt-4 flex flex-wrap gap-x-5 gap-y-2" data-id="element-630" data-mp="34jjbm10isrxo">
                          {service.highlights.map(highlight => <span key={highlight} className="flex items-center gap-2 text-sm font-medium text-sky-200" data-id="element-631" data-mp="2bsrgz7z3sbcg">
                              <CheckIcon className="h-4 w-4" data-id="element-632" data-mp="2gqt2dzk04mr3" />
                              {highlight}
                            </span>)}
                        </span>
                      </motion.span>}
                  </AnimatePresence>
                </span>
              </motion.button>;
        })}
        </div>

        {/* Mobile / tablet: stacked cards */}
        <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:hidden" data-id="element-633" data-mp="12sy712lzcly">
          {services.map(service => <li key={service.name} className="flex h-full flex-col overflow-hidden rounded-lg bg-navy-800" data-id="element-634" data-mp="544prc51m7ws">
              <div className="relative h-40" data-id="element-635" data-mp="3mplibs2i89h">
                <img src={service.image} alt={service.imageAlt} className="h-full w-full object-cover" data-id="element-636" data-mp="3us8xzh1webk1" />
                <span aria-hidden="true" className="absolute inset-0 bg-navy-900/45" data-id="element-637" data-mp="dju1tuz8f9id" />
                <service.icon className="absolute left-4 top-4 h-7 w-7 text-white" data-id="element-638" data-mp="8ixybiislpdh" />
              </div>
              <div className="flex flex-1 flex-col p-5" data-id="element-639" data-mp="mip97ae0ipn9">
                <h3 className="font-display text-lg font-bold text-white" data-id="element-640" data-mp="hknnehp7cc83">{service.name}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-navy-100" data-id="element-641" data-mp="hitb1rrzxsfm">{service.body}</p>
                <ul className="mt-auto flex flex-wrap gap-x-4 gap-y-2 pt-4" data-id="element-642" data-mp="wbeflquphdbq">
                  {service.highlights.map(highlight => <li key={highlight} className="flex items-center gap-2 text-sm font-medium text-sky-200" data-id="element-643" data-mp="159ysuchhyusk">
                      <CheckIcon className="h-4 w-4" data-id="element-644" data-mp="1196i1esz8hu6" />
                      {highlight}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}